import { useContext, useState } from 'react';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import FacetDataContext from '~/contexts/FacetDataContext';
import type { AppliedListFilters } from '~/contracts';
import Checkbox from './Checkbox';
import FilterDrawer from './FilterDrawer';
import LabelWithCount from './LabelWithCount';
import { CommonWrapper } from './styles';
import type WithClassName from './WithClassName';

type OwnProps = WithClassName & {
  checkboxClassName?: string;
  filterKey: keyof Omit<AppliedListFilters, 'makes'>;
  title: string;
};

// This component only works when baseline and appliedFilters keys are identical
const SimpleCheckboxList = ({
  checkboxClassName,
  className,
  filterKey,
  title
}: OwnProps) => {
  const [show, setShow] = useState(false);
  const { facetData } = useContext(FacetDataContext);
  const { appliedFilters, updateListFilter } = useContext(
    AppliedFiltersContext
  );
  const data = facetData[filterKey]?.buckets ?? [];
  const list: any[] = appliedFilters[filterKey] ?? [];

  return (
    <FilterDrawer
      className={className}
      dataQa={`facet-${filterKey}`}
      facetContent={data}
      facetName={title}
      show={show}
      onToggle={() => {
        setShow(!show);
      }}
    >
      <CommonWrapper>
        {data.map(({ key, count, displayName }) => (
          <Checkbox
            className={checkboxClassName}
            checked={list.includes(key)}
            facet={filterKey}
            filter={key}
            id={`${filterKey}-${key}`}
            key={key}
            label={<LabelWithCount count={count} displayName={displayName} />}
            onChange={() =>
              updateListFilter({
                filterKey,
                value: key
              })
            }
          />
        ))}
      </CommonWrapper>
    </FilterDrawer>
  );
};

export default SimpleCheckboxList;
